import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { Module } from "types/generated";
import { AccessResult, hasAtLeastWriteAccess, NO_ACCESS_MESSAGE } from "utils/access";

// FYI: the "module.canWrite" check here is for legacy stacks (could be affected by access policies)
const useHasModuleWriteAccess = (): ((module?: Module) => AccessResult) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (module?: Module) => {
      if (!module) {
        return { result: false };
      }

      if (viewer.admin || module.canWrite) {
        return { result: true };
      }

      const result = hasAtLeastWriteAccess(viewer, module.spaceDetails?.id || module.space);

      if (result) {
        return { result: true };
      }

      return { result: false, message: NO_ACCESS_MESSAGE };
    },
    [viewer]
  );
};

export default useHasModuleWriteAccess;
